import { useContext, useEffect, useRef } from 'react'

import { InstallAppContext } from '@app/context'
import { promptInstall } from '@app/helpers/pwaTracking'

export const useInstallPrompt = (storageKey?: string) => {
  const { event: installEvent, setEvent } = useContext(InstallAppContext)

  const hasPrompted = useRef(false)

  const installApp = async () => {
    if (!installEvent) return

    try {
      await promptInstall(installEvent, storageKey ?? 'auto_prompt')

      setEvent(null)
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    if (!installEvent) return
    if (hasPrompted.current) return

    if (storageKey) {
      const shouldPrompt =
        sessionStorage.getItem(storageKey) === 'true'

      if (!shouldPrompt) return

      sessionStorage.removeItem(storageKey)
    }

    hasPrompted.current = true
    void installApp()
  }, [installEvent, storageKey])
}
